import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export const FaqAccordion = () => (
  <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
    {FAQS.map((f, i) => (
      <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl bg-crate-surface border border-white/10 px-6 data-[state=open]:border-crate-yellow transition-colors">
        <AccordionTrigger className="text-left font-heading font-semibold text-white hover:no-underline text-base md:text-lg py-5" data-testid={`faq-trigger-${i}`}>
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="text-white/60 leading-relaxed text-base pb-5">
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
